import { render } from "./Config.vue?vue&type=template&id=0d28b7bc&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=0d28b7bc&lang=scss&scoped=true"

import exportComponent from "/Users/ganl/Code/vue-digital-transform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d28b7bc"]])

export default __exports__